import { deleteCookie, getCookie, hasCookie, setCookie } from 'cookies-next';
import { GetServerSidePropsContext } from 'next/types';

type ParsedPreviewUserUuidQueryParam = string | undefined;

export const PREVIEW_USER_UUID_KEY = 'preview_user_uuid';

const previewCookieOptions = {
  path: '/',
  maxAge: 3600, // 1 hour
  domain:
    process.env.NODE_ENV === 'development'
      ? 'localhost'
      : process.env.NEXT_PUBLIC_BACKEND_DOMAIN,
};

export function deleteAdminPreviewCookie(context: GetServerSidePropsContext) {
  const { req, res } = context;
  if (hasCookie(PREVIEW_USER_UUID_KEY, { req, res })) {
    deleteCookie(PREVIEW_USER_UUID_KEY, previewCookieOptions);
  }
}

export function deleteAdminPreviewCookieFromClient() {
  if (hasCookie(PREVIEW_USER_UUID_KEY)) {
    deleteCookie(PREVIEW_USER_UUID_KEY, previewCookieOptions);
  }
}

export function getAdminPreviewCookie(context: GetServerSidePropsContext) {
  const { req, res } = context;

  return getCookie(PREVIEW_USER_UUID_KEY, {
    req,
    res,
  });
}

export function getAdminPreviewQueryParam(context: GetServerSidePropsContext) {
  const { query } = context;

  return query[PREVIEW_USER_UUID_KEY] as ParsedPreviewUserUuidQueryParam;
}

export function setAdminPreviewCookie(
  previewUserUuid: string,
  context: GetServerSidePropsContext,
) {
  const { req, res } = context;

  setCookie(PREVIEW_USER_UUID_KEY, previewUserUuid, {
    req,
    res,
    ...previewCookieOptions,
  });
}

export function maybeGetPreviewUserUuid(context: GetServerSidePropsContext) {
  const previewUserUuidQueryParam = getAdminPreviewQueryParam(context);
  const previewUserUuidCookie = getAdminPreviewCookie(context);

  // first preview visit, persist cookie
  if (!previewUserUuidCookie && previewUserUuidQueryParam) {
    setAdminPreviewCookie(previewUserUuidQueryParam, context);
  }

  // switching preview users, update cookie
  if (
    previewUserUuidCookie &&
    previewUserUuidQueryParam &&
    previewUserUuidCookie !== previewUserUuidQueryParam
  ) {
    setAdminPreviewCookie(previewUserUuidQueryParam, context);
  }

  return previewUserUuidQueryParam || previewUserUuidCookie;
}
